import { render } from "./personal-center.vue?vue&type=template&id=312f9e6b"
import script from "./personal-center.vue?vue&type=script&lang=js"
export * from "./personal-center.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__